// ProcessDescriptionAners.js
// Componente para a aba 1 - Descrição do Processo.

import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from 'react-select';

const ProcessDescriptionAners = ({
    id,
    idProcess,
    token,
    responseProcess,
    responseForum,
    responsePessoa,
    responseAcao,
    setSelectedPayment,
}) => {
    // Estado local para gerenciar os dados do formulário
    const [formData, setFormData] = useState(responseProcess);

    // FORMATA OS DADOS DE 'responsePessoa' PARA O FORMATO DO REACT-SELECT
    const pessoaOptions = React.useMemo(() => 
        responsePessoa.map(dados => ({
            value: dados.nome,
            label: dados.nome
        })), 
    [responsePessoa]);

    
    // UseEffect para sincronizar o estado local caso a prop 'responseProcess' mude
    // Isso garante que se o usuário selecionar outro processo, o formulário será atualizado
    useEffect(() => {
        setFormData(responseProcess);
    }, [responseProcess]);
    
    // Manipulador de eventos para todos os campos do formulário.
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // O react-select passa o objeto da opção selecionada, não um evento do DOM.
    const handleSelectChange = (selectedOption, actionMeta) => {
        const { name } = actionMeta; // 'name' vem da prop do componente <Select>
        const value = selectedOption ? selectedOption.value : ""; // Pega o valor ou zera se for limpo

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    console.log(formData)
    
    const formatCurrency = (value) => {
        // Se o valor for nulo, indefinido ou vazio, retorna uma string vazia.
        if (!value) return "";

        // Lógica de formatação adaptada da sua função original
        const formattedValue = String(value)
            .replace(/\D/g, "") // Remove tudo que não for número
            .replace(/^0+/, "") // Remove os zeros à esquerda
            .padStart(3, "0") // Garante que tenha pelo menos 3 dígitos (para centavos)
            .replace(/(\d{1,})(\d{2})$/, "$1,$2") // Coloca a vírgula dos centavos
            .replace(/(?=(\d{3})+(\D))\B/g, "."); // Coloca os pontos de milhar

        return `R$ ${formattedValue}`;
    };

    // Função de máscara de dinheiro
    const handleMoneyChange = (event) => {
        const { name, value } = event.target;

        // Extrai apenas os dígitos do valor que o usuário digitou
        const rawValue = value.replace(/\D/g, "");

        // Atualiza o estado 'valor_causa' apenas com os números
        setFormData((prevData) => ({
            ...prevData,
            [name]: rawValue,
        }));
    };

    function updateProcess() {
        const divErros = document.querySelector("#erros");
        const divErrosAll = divErros.querySelectorAll(".row");
        const id = idProcess; // ID do processo a ser atualizado
        console.log(id);
        axios
            .post(
                `/api/update/process/${id}`,
                {
                    // Envie os dados diretamente do estado 'formData'
                    token,
                    processo: formData.processo,
                    valorEstimado: formData.valor_causa,
                    forum: formData.forum,
                    inicioProcesso: formData.data_inicio,
                    estimada: formData.data_estimada,
                    acao: formData.id_acao,
                    pasta: formData.pasta,
                    observacao: formData.observacao,
                    advogado: formData.advogado,
                    reu: formData.reu,
                    autor: formData.autor,
                    advAutor: formData.advAutor,
                },
                {
                    withCredentials: true,
                }
            )
            .then((resp) => {
                console.log(resp)
                if (resp.data == 400) {
                    window.location = `/ci/pagamentos/erro`;
                }
                if (resp.data == 404) {
                    alert("Erro no servidor! Processo não encontrado.");
                }
                if (resp.data.erros.length === 0) {
                    window.location = `/ci/pagamentos/${id}`;
                } else {
                    for (let i = 0; i < resp.data.erros.length; i++) {
                        for (let c = 0; c < divErrosAll.length; c++) {
                            divErrosAll[c].remove();
                        }

                        let elemento = document.querySelector(
                            `#${resp.data.erros[i].elemento}`
                        );
                        elemento.style.backgroundColor = "#FFC0CB";
                        let divRow = document.createElement("div"); // Cria o elemento div
                        divRow.className = "row mt-3"; // Adiciona uma margem superior de 3 unidades
                        //divRow.style.backgroundColor = '#FFC0CB' // Define a cor de fundo da div
                        divRow.style.padding = "10px"; // Define um espaçamento interno de 10 pixels
                        divRow.style.borderRadius = "5px"; // Define um raio de borda de 5 pixels
                        let divCol = document.createElement("div"); // Cria o elemento div
                        divCol.style.display = "inline-block";
                        divCol.style.backgroundColor = "#FFC0CB";
                        let divText = document.createTextNode(
                            `${resp.data.erros[i].mensagem}`
                        ); // Cria o elemento de texto
                        divCol.appendChild(divText); // Adiciona o texto como filho de divCol
                        divRow.appendChild(divCol);
                        divErros.appendChild(divRow);
                    }
                }
            });
    }

    return (
        <div className="tab-pane fade show active" id={id} role="tabpanel">
            <div className="row" id="erros" style={{ marginTop: 25 }}></div>
            <div className="row" style={{ marginTop: 25 }}>
                <div className="col-12">
                    <h4>Cliente: {formData.nome_client}</h4>
                </div>
            </div>
            <section>
                <div className="row" style={{ marginTop: 13 }}>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="required">Processo</label>
                            <input
                                type="text"
                                className="form-control"
                                id="processo"
                                placeholder="Número do Processo do Documento"
                                value={formData.processo || ""}
                                onChange={handleInputChange}
                                name="processo"
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="required">
                                Valor Estimado da Causa
                            </label>
                            <input
                                type="text"
                                id="valorEstimado"
                                value={formatCurrency(formData.valor_causa)}
                                className="form-control"
                                onChange={handleMoneyChange}
                                name="valor_causa"
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="required">Fórum</label>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <button
                                        className="btn btn-outline-success"
                                        type="button"
                                        data-toggle="modal"
                                        data-target="#forumModal">
                                        Adicionar
                                    </button>
                                </div>
                                <select
                                    id="forum"
                                    name="forum"
                                    className="form-control"
                                    value={formData.forum || ""}
                                    onChange={handleInputChange}>
                                    <option value={formData.forum}>
                                        {formData.forum}
                                    </option>
                                    {responseForum.map((res, index) => (
                                        <option
                                            key={index}
                                            value={res.descricao}>
                                            {res.descricao}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="required">
                                Data do Início do Processo
                            </label>
                            <div
                                className="input-group date"
                                id="reservationdate"
                                data-target-input="nearest">
                                <input
                                    type="date"
                                    id="inicioProcesso"
                                    className="form-control datetimepicker-input"
                                    data-target="#reservationdate"
                                    name="data_inicio"
                                    value={formData.data_inicio || ""}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="required">
                                Data Estimada do Processo
                            </label>
                            <div
                                className="input-group date"
                                id="reservationdate"
                                data-target-input="nearest">
                                <input
                                    type="date"
                                    id="estimada"
                                    className="form-control datetimepicker-input"
                                    name="data_estimada"
                                    data-target="#reservationdate"
                                    value={formData.data_estimada || ""}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="required">
                                Selecione uma Ação
                            </label>
                            <select
                                className="form-control"
                                id="acao"
                                name="id_acao"
                                value={formData.id_acao || ""}
                                onChange={handleInputChange}>
                                <option value="" disabled>
                                    Selecione...
                                </option>
                                {responseAcao.map((acao) => (
                                    // Para cada ação, criamos uma opção.
                                    <option key={acao.id} value={acao.id}>
                                        {/* O VALOR da opção é o ID, mas o TEXTO exibido é o NOME. */}
                                        {acao.nome}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="required">
                                Informe o Número da Pasta
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="pasta"
                                name="pasta"
                                placeholder=""
                                value={formData.pasta || ""}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Advogado (a) réu</label>
                            <br />
                            <div
                                className="div-button-success text-white"
                                title="Adicionar Nova Pessoa"
                                data-toggle="modal"
                                data-target="#novaentidade">
                                <i
                                    className="fas fa-plus"
                                    style={{ marginLeft: "5px" }}></i>
                                Adicionar Nova Pessoa
                            </div>
                            <Select
                                name="advogado"
                                id="advogado"
                                options={pessoaOptions}
                                isClearable
                                isSearchable
                                placeholder="Selecione ou busque o advogado..."
                                value={pessoaOptions.find(option => option.value === formData.advogado) || null}
                                onChange={handleSelectChange}
                                noOptionsMessage={() => "Nenhuma pessoa encontrada"}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Réu</label>
                            <br />
                            <div
                                className="div-button-success text-white"
                                title="Adicionar Nova Pessoa"
                                data-toggle="modal"
                                data-target="#novaentidade">
                                <i
                                    className="fas fa-plus"
                                    style={{ marginLeft: "5px" }}></i>
                                Adicionar Nova Pessoa
                            </div>
                            <Select
                                name="reu"
                                id="reu"
                                options={pessoaOptions}
                                isClearable
                                isSearchable
                                placeholder="Selecione ou busque o réu..."
                                value={pessoaOptions.find(option => option.value === formData.reu) || null}
                                onChange={handleSelectChange}
                                noOptionsMessage={() => "Nenhuma pessoa encontrada"}
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Advogado (a) autor</label>
                            <br />
                            <div
                                className="div-button-success text-white"
                                title="Adicionar Nova Pessoa"
                                data-toggle="modal"
                                data-target="#novaentidade">
                                <i
                                    className="fas fa-plus"
                                    style={{ marginLeft: "5px" }}></i>
                                Adicionar Nova Pessoa
                            </div>
                            <Select
                                name="advAutor"
                                id="advAutor"
                                options={pessoaOptions}
                                isClearable
                                isSearchable
                                placeholder="Selecione ou busque o advogado..."
                                value={pessoaOptions.find(option => option.value === formData.advAutor) || null}
                                onChange={handleSelectChange}
                                noOptionsMessage={() => "Nenhuma pessoa encontrada"}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Autor</label>
                            <br />
                            <div
                                className="div-button-success text-white"
                                title="Adicionar Nova Pessoa"
                                data-toggle="modal"
                                data-target="#novaentidade">
                                <i
                                    className="fas fa-plus"
                                    style={{ marginLeft: "5px" }}></i>
                                Adicionar Nova Pessoa
                            </div>
                            <Select
                                name="autor"
                                id="autor"
                                options={pessoaOptions}
                                isClearable
                                isSearchable
                                placeholder="Selecione ou busque o autor..."
                                value={pessoaOptions.find(option => option.value === formData.autor) || null}
                                onChange={handleSelectChange}
                                noOptionsMessage={() => "Nenhuma pessoa encontrada"}
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label>Observação</label>
                            <textarea
                                id="observacao"
                                className="form-control"
                                rows="6"
                                name="observacao"
                                value={formData.observacao || ""}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="center-element">
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={updateProcess}>
                        Atualizar
                    </button>
                </div>
            </section>
            <form
                action={`/api/observation/${responseProcess.id}`}
                method="post">
                <div className="col-md-12">
                    <div className="form-group">
                        <i className="fa fa-comment"></i>
                        <label>Comentários</label>
                        <textarea
                            id="comentarios"
                            className="form-control"
                            name="observation"
                            rows="6"
                            placeholder="Deixe aqui seu comentário..."
                        />
                    </div>
                    <div className="col-xs-12 text-center">
                        <button
                            className="btn btn-info"
                            id="comentar"
                            type="submit">
                            <i className="fa fa-comment"></i> Comentar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ProcessDescriptionAners;
